import axios from 'axios';
import { Dispatch } from 'redux';
import { notifyUser } from '@core/utils/src/userInteraction/notifications';
import { NotifyType } from '@core/utils/src/userInteraction/notifications/types';
import { setUserData, signOutUser } from '../redux/actions';
import i18n from 'i18next';
import Api from '../api/user';

const interceptorsSetup = (
  jwt: string,
  refreshToken: string,
  dispatch: Dispatch
) =>
  axios.interceptors.response.use(
    (res) => res,
    async (error) => {
      if (axios.isCancel(error)) {
        return { hasCanceled: true };
      }

      if (error.response.status === 404) {
        return Promise.reject({
          response: error.response,
          message: i18n.t('NotFoundApiErr')
        });
      }

      if (error.response.status === 401) {
        try {
          const { data } = await Api.refreshJWT({ jwt, refreshToken });

          axios.defaults.headers.common.Authorization = `Bearer ${data.accessToken}`;

          localStorage.setItem('jwt', data.accessToken);
          localStorage.setItem('refreshToken', data.refreshToken);

          dispatch(
            setUserData({
              data: data.data,
              jwt: data.accessToken,
              refreshToken: data.refreshToken
            })
          );

          return await axios.request(error.config);
        } catch {
          notifyUser({
            msg: i18n.t('SesjaWygasla'),
            type: NotifyType.WARNING
          });
          dispatch(signOutUser());
        }
      }

      return Promise.reject(error);
    }
  );

export const axiosSetup = (
  jwt: string,
  refreshToken: string,
  dispatch: Dispatch,
  axiosInterceptor: React.MutableRefObject<number | null>
) => {
  if (jwt.length > 0) {
    axios.defaults.headers.common.Authorization = `Bearer ${jwt}`;

    return interceptorsSetup(jwt, refreshToken, dispatch);
  }

  if (axiosInterceptor.current !== null) {
    axios.interceptors.response.eject(axiosInterceptor.current);
  }

  if (axios.defaults.headers.common.Authorization) {
    delete axios.defaults.headers.common.Authorization;
  }

  return null;
};
